/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
/**
 * Calculates the maximum required width (in pixels) for a column based on its content,
 * ensuring that all values are fully visible when rendered.
 *
 * @param data - Array of data objects
 * @param getter - Function to extract text content from each data object
 * @param options - Configuration options
 * @param options.padding - Additional padding to add (default: 0)
 * @param options.basePadding - Base padding added to all columns (default: 26)
 * @param options.minWidth - Minimum width to return (default: 40)
 * @returns The calculated maximum width
 *
 * @example
 * ```typescript
 * const data = [{ name: 'John Doe' }, { name: 'Jane Smith' }];
 * const width = calculateMaxColumnWidth(data, (row) => row.name, { padding: 10 });
 * ```
 */
export function calculateMaxColumnWidth<T>(
  data: T[],
  getter: (row: T) => string,
  {
    padding = 0,
    basePadding = 26,
    minWidth = 40,
  }: {
    padding?: number;
    basePadding?: number;
    minWidth?: number;
  } = {},
): number {
  if (!data || data.length === 0) {
    return minWidth;
  }

  const values = data.map(getter).filter((text): text is string => text != null && text !== '');
  if (values.length === 0) {
    return minWidth;
  }

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  // Fallback if canvas context is not available
  if (!ctx) {
    const maxLength = Math.max(...values.map((text) => text.length));
    return Math.max(minWidth, maxLength * 8 + basePadding + padding);
  }

  ctx.font = '14px Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

  const measuredValues = values.map((text) => ({
    text,
    width: ctx.measureText(text).width,
  }));

  const sorted = measuredValues.sort((a, b) => a.width - b.width);
  const maxWidth = sorted[sorted.length - 1].width + basePadding + padding;

  return Math.max(minWidth, maxWidth);
}
